import { NgModule } from '@angular/core';

import { SafePipe, OrderByPipe } from './safe.pipe';

@NgModule({
  declarations: [SafePipe, OrderByPipe],
  exports: [SafePipe]
})
export class PipeModule { }
